module.exports = __webpack_public_path__ + "img/upload.2958e296.svg";